module.exports = __webpack_public_path__ + "static/media/bgi-openscout-devstarXD-8@3x.c0d4b504.png";